import { Link } from "react-router-dom";
import Header from "../components/Header";

const CONTAINER = "mx-auto max-w-3xl px-6 py-16";
const H1 = "text-3xl font-semibold tracking-tight text-slate-900";
const H2 = "mt-10 text-xl font-semibold text-slate-900";
const P = "mt-3 text-sm leading-relaxed text-slate-700";

export default function LegalPrivacy() {
  return (
    <div className="min-h-screen bg-white" data-testid="legal-privacy-page">
      <Header />
      <main className={CONTAINER}>
        <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-900" data-testid="legal-provisional-banner">
          <strong>Provisional version</strong> — this policy is a working draft and has not been
          reviewed by counsel. Consult a licensed US attorney before commercial launch.
        </div>
        <p className="text-xs font-semibold uppercase tracking-wider text-indigo-700">Legal</p>
        <h1 className={H1}>Privacy Policy</h1>
        <p className="mt-2 text-xs text-slate-500">Effective date: 07/30/2026</p>

        <h2 className={H2}>1. Data we collect</h2>
        <p className={P}>
          When you use Talent Junction, we collect:
        </p>
        <ul className="mt-2 list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li><strong>Account data</strong> — name, email, hashed password, role, organization.</li>
          <li><strong>Business content</strong> — missions, proposals, messages, ratings, consultant profiles you publish.</li>
          <li><strong>Billing data</strong> — via Stripe: last-four card digits, customer ID, invoices. Full card numbers are never stored on our servers.</li>
          <li><strong>Technical data</strong> — IP address, browser user-agent, and access timestamps for security and audit.</li>
        </ul>

        <h2 className={H2}>2. How we use it</h2>
        <p className={P}>
          We use your data to operate the marketplace, match Employers with Agencies, process
          subscription billing, send transactional emails (account approval, password reset,
          notifications), and secure the platform. We do not sell personal data.
        </p>

        <h2 className={H2}>3. Third-party processors</h2>
        <ul className="mt-2 list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li><strong>Stripe, Inc.</strong> — payment processing (US, SOC 2, PCI DSS).</li>
          <li><strong>Resend</strong> — transactional email delivery (US-based).</li>
          <li><strong>MongoDB Atlas</strong> — database hosting (US region).</li>
          <li><strong>OpenStreetMap Nominatim</strong> — city-level geocoding (public data, no personal info sent).</li>
        </ul>

        <h2 className={H2}>4. Retention</h2>
        <p className={P}>
          We retain account and business data for the duration of your account plus 3 years after
          closure, unless a longer period is required by law (e.g., tax records: 7 years). You may
          request earlier deletion — see Section 6.
        </p>

        <h2 className={H2}>5. Your rights</h2>
        <p className={P}>
          Depending on where you live, you may have rights under the CCPA (California), GDPR (EU/UK),
          or other laws:
        </p>
        <ul className="mt-2 list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li>Access and portability of your data</li>
          <li>Rectification of inaccurate data</li>
          <li>Deletion (subject to legal retention obligations)</li>
          <li>Objection to certain processing</li>
          <li>Non-discrimination for exercising your rights</li>
        </ul>

        <h2 className={H2}>6. How to exercise your rights</h2>
        <p className={P}>
          Email us at{" "}
          <a href="mailto:contact@talentjunction.io" className="text-indigo-700 hover:underline">contact@talentjunction.io</a>{" "}
          with your request. We'll respond within 30 days.
        </p>

        <h2 className={H2}>7. Security</h2>
        <p className={P}>
          We use industry-standard measures: TLS encryption in transit, bcrypt password hashing,
          JWT with token version invalidation, and access controls on our infrastructure. No system
          is 100% secure — we notify you if a breach affects your data.
        </p>

        <h2 className={H2}>8. Cookies</h2>
        <p className={P}>
          See our <Link to="/legal/cookies" className="text-indigo-700 hover:underline">Cookie Policy</Link>{" "}
          for details.
        </p>

        <h2 className={H2}>9. Children</h2>
        <p className={P}>
          Talent Junction is not directed at children under 16 and we do not knowingly collect
          data from them.
        </p>

        <h2 className={H2}>10. Contact</h2>
        <p className={P}>
          Talent Junction, Inc. — 169 Madison Ave, New York, NY 10016 —{" "}
          <a href="mailto:contact@talentjunction.io" className="text-indigo-700 hover:underline">contact@talentjunction.io</a>.
        </p>

        <p className="mt-10 text-xs text-slate-500">Last updated: 07/30/2026 · Provisional draft.</p>
      </main>
    </div>
  );
}
